module.exports = __webpack_public_path__ + "imgs/arrow-right.9ce6af2b5061c752d3816cb9d5bbab83.svg";